import { Injectable } from '@angular/core'
import { EditHoldDialogComponent } from './edit-hold-dialog.component'
import { CalendarEvent } from '@tv3/store/calendar/calendar.model'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'

@Injectable()
export class EditHoldDialogService {
  constructor(private dialog: MatDialog) {}

  open(hold: CalendarEvent, deletable = false, convertable = false) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: { hold, deletable, convertable },
    }

    return this.dialog.open(EditHoldDialogComponent, defaultConfig)
  }
}
